import React from 'react';
// import './Wall.scss';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ImageUploader from 'react-images-upload';
import ContentLoader from 'react-content-loader';
import { IconDelete } from '../../img';

const IconCard = ({
  handleBase64File,
  updWidgetIcon,
  isLoadIcon,
  isLoadIconscout,
  handleIconChange,
  iconLabel,
  deleteIcon,
  myIcon,
  native,
  iconValidator,
  iconscout,
  arrIconscout,
  handleIconTextChange,
  handleIconKeypress,
  searchIconscout,
  handleIconscoutFile
}) => {
  return (
    <div className="modal-body wdgt-icon-setting">
      <div className="mdl-icon-upload">
        <ImageUploader
          className='simpple'
          fileContainerStyle={{ padding: 0, display: 'block', background: 'rgba(0,0,0,0)', WebkitBoxShadow: 'none', boxShadow: 'none', margin: 0 }}
          buttonClassName=''
          buttonStyles={{}} 
          withIcon={false}
          withLabel={true}
          label={iconLabel ? iconLabel : ''}
          labelStyles={{ float: 'right' }}
          buttonText='Choose icon'
          singleImage={true}
          onChange={handleBase64File}
          imgExtension={['.jpg', '.jpeg', '.png', '.svg', '.gif']}
          maxFileSize={5242880} />
        <input className="nf-btn nf-btn-default nf-btn-min15x nf-btn-minW" type='button' value='UPLOAD' onClick={() => updWidgetIcon()} />
      </div>
      <div className="">
        {
          (isLoadIcon == false) ?
            <div className="design-template-tab design-tab">
              <div className="design-tab-inblock">
                <Tabs className="nf-default-tabs wg-default-editor tab-iconmodal-block">
                  <TabList className="wg-tabs-secstyle wg-tabs-iconmodaltab">
                    <Tab>All</Tab>
                    <Tab>My Icon</Tab>
                    <Tab>Iconscout</Tab>
                    <Tab>Native icon</Tab>
                  </TabList>
                  <TabPanel>
                    <div className="wdgt-iconmodal-block wdgt-iconmodal-secblock wdgt-iconmodal-scroll">
                      {(myIcon && myIcon.length > 0) &&
                        <div className="icon-gallery-caterow">
                          <h4 className="icon-gallery-subtitle">My</h4>
                          <div className="wdgt-iconmodal-contant">
                            {
                              myIcon.map((val, key) => {
                                return (
                                  <div className="icon-gallery-item" key={key}>
                                    <div className="icon-gallery-box">
                                      <span className="btn-action tbl-action-dlt action-dlt-icongallery " onClick={() => deleteIcon(val._id, val.iu)}>
                                        <img className="" src={IconDelete} />
                                      </span>
                                      <img src={val.iu} onClick={() => handleIconChange(val.iu)}></img>
                                    </div>
                                  </div>
                                );
                              })
                            }
                          </div>
                        </div>
                      }
                      {(native && native.length > 0) &&
                        <div className="icon-gallery-caterow">
                          <h4 className="icon-gallery-subtitle">Native</h4>
                          <div className="wdgt-iconmodal-contant">
                            {
                              native.map((val, key) => {
                                return (
                                  <div className="icon-gallery-item" key={key}>
                                    <div className="icon-gallery-box">
                                      <img src={val.iu} onClick={() => handleIconChange(val.iu)}></img>
                                    </div>
                                  </div>
                                );
                              })
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="wdgt-iconmodal-block wdgt-iconmodal-secblock wdgt-iconmodal-scroll">
                      {(myIcon && myIcon.length > 0) &&
                        <div className="icon-gallery-caterow">
                          <h4 className="icon-gallery-subtitle">My</h4>
                          <div className="wdgt-iconmodal-contant">
                            {
                              myIcon.map((val, key) => {
                                return (
                                  <div className="icon-gallery-item" key={key}>
                                    <div className="icon-gallery-box">
                                      <span className="btn-action tbl-action-dlt action-dlt-icongallery " onClick={() => deleteIcon(val._id, val.iu)}>
                                        <img className="" src={IconDelete} />
                                      </span>
                                      <img src={val.iu} onClick={() => handleIconChange(val.iu)}></img>
                                    </div>
                                  </div>
                                );
                              })
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="wdgt-iconmodal-block wdgt-iconmodal-secblock">
                      <div className="iconscout-form-search">
                        <div className="iconscout-input-btn">
                          <input type='text' placeholder='Type icon name & click on search' className='nf-input nf-input-sm' value={iconscout} onChange={(e) => handleIconTextChange(e.target.value)} onKeyPress={(e) => handleIconKeypress(e)} />
                          <input className="nf-btn nf-btn-default  nf-btn-min15x" type='button' value='SEARCH' onClick={() => searchIconscout()} />
                        </div>
                        {iconValidator.message('icon name', iconscout, 'required')}
                      </div>
                      {
                        isLoadIconscout == false ?
                          <div className="wdgt-iconmodal-contant wdgt-iconmodal-scroll">
                            {(arrIconscout && arrIconscout.length > 0) ?
                              arrIconscout.map((val, key) => {
                                return (
                                  <div className="icon-gallery-item" key={key} onClick={() => handleIconscoutFile(val)}>
                                    <div className="icon-gallery-box">
                                      <img src={val}></img>
                                    </div>
                                  </div>
                                );
                              }) :
                              <p className='iconscout-no-record text-center'>No record found</p>
                            }
                          </div>
                          :
                          <ContentLoader
                            height={450}
                            width={700}
                            speed={2}
                            primaryColor="#eceef4"
                            secondaryColor="#fff">
                            <rect x="20" y="25" rx="0" ry="0" width="75" height="75" />
                            <rect x="110" y="25" rx="0" ry="0" width="75" height="75" />
                            <rect x="200" y="25" rx="0" ry="0" width="75" height="75" />
                            <rect x="290" y="25" rx="0" ry="0" width="75" height="75" />
                            <rect x="380" y="25" rx="0" ry="0" width="75" height="75" />
                            <rect x="470" y="25" rx="0" ry="0" width="75" height="75" />
                            <rect x="560" y="25" rx="0" ry="0" width="75" height="75" />

                            <rect x="20" y="115" rx="0" ry="0" width="75" height="75" />
                            <rect x="110" y="115" rx="0" ry="0" width="75" height="75" />
                            <rect x="200" y="115" rx="0" ry="0" width="75" height="75" />
                            <rect x="290" y="115" rx="0" ry="0" width="75" height="75" />
                            <rect x="380" y="115" rx="0" ry="0" width="75" height="75" />
                            <rect x="470" y="115" rx="0" ry="0" width="75" height="75" />
                            <rect x="560" y="115" rx="0" ry="0" width="75" height="75" />

                            <rect x="20" y="205" rx="0" ry="0" width="75" height="75" />
                            <rect x="110" y="205" rx="0" ry="0" width="75" height="75" />
                            <rect x="200" y="205" rx="0" ry="0" width="75" height="75" />
                            <rect x="290" y="205" rx="0" ry="0" width="75" height="75" />
                            <rect x="380" y="205" rx="0" ry="0" width="75" height="75" />
                            <rect x="470" y="205" rx="0" ry="0" width="75" height="75" />
                            <rect x="560" y="205" rx="0" ry="0" width="75" height="75" />

                            <rect x="20" y="295" rx="0" ry="0" width="75" height="75" />
                            <rect x="110" y="295" rx="0" ry="0" width="75" height="75" />
                            <rect x="200" y="295" rx="0" ry="0" width="75" height="75" />
                            <rect x="290" y="295" rx="0" ry="0" width="75" height="75" />
                            <rect x="380" y="295" rx="0" ry="0" width="75" height="75" />
                            <rect x="470" y="295" rx="0" ry="0" width="75" height="75" />
                            <rect x="560" y="295" rx="0" ry="0" width="75" height="75" />
                          </ContentLoader>
                      }
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="wdgt-iconmodal-block wdgt-iconmodal-secblock wdgt-iconmodal-scroll">
                      {(native && native.length > 0) &&
                        <div className="icon-gallery-caterow mt-15">
                          <div className="wdgt-iconmodal-contant">
                            {
                              native.map((val, key) => {
                                return (
                                  <div className="icon-gallery-item" key={key}>
                                    <div className="icon-gallery-box">
                                      <img src={val.iu} onClick={() => handleIconChange(val.iu)}></img>
                                    </div>
                                  </div>
                                );
                              })
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
            :
            <ContentLoader
              height={450}
              width={700}
              speed={2}
              primaryColor="#eceef4"
              secondaryColor="#fff">
              <rect x="20" y="25" rx="0" ry="0" width="75" height="75" />
              <rect x="110" y="25" rx="0" ry="0" width="75" height="75" />
              <rect x="200" y="25" rx="0" ry="0" width="75" height="75" />
              <rect x="290" y="25" rx="0" ry="0" width="75" height="75" />
              <rect x="380" y="25" rx="0" ry="0" width="75" height="75" />
              <rect x="470" y="25" rx="0" ry="0" width="75" height="75" />
              <rect x="560" y="25" rx="0" ry="0" width="75" height="75" />

              <rect x="20" y="115" rx="0" ry="0" width="75" height="75" />
              <rect x="110" y="115" rx="0" ry="0" width="75" height="75" />
              <rect x="200" y="115" rx="0" ry="0" width="75" height="75" />
              <rect x="290" y="115" rx="0" ry="0" width="75" height="75" />
              <rect x="380" y="115" rx="0" ry="0" width="75" height="75" />
              <rect x="470" y="115" rx="0" ry="0" width="75" height="75" />
              <rect x="560" y="115" rx="0" ry="0" width="75" height="75" />

              <rect x="20" y="205" rx="0" ry="0" width="75" height="75" />
              <rect x="110" y="205" rx="0" ry="0" width="75" height="75" />
              <rect x="200" y="205" rx="0" ry="0" width="75" height="75" />
              <rect x="290" y="205" rx="0" ry="0" width="75" height="75" />
              <rect x="380" y="205" rx="0" ry="0" width="75" height="75" />
              <rect x="470" y="205" rx="0" ry="0" width="75" height="75" />
              <rect x="560" y="205" rx="0" ry="0" width="75" height="75" />

              <rect x="20" y="295" rx="0" ry="0" width="75" height="75" />
              <rect x="110" y="295" rx="0" ry="0" width="75" height="75" />
              <rect x="200" y="295" rx="0" ry="0" width="75" height="75" />
              <rect x="290" y="295" rx="0" ry="0" width="75" height="75" />
              <rect x="380" y="295" rx="0" ry="0" width="75" height="75" />
              <rect x="470" y="295" rx="0" ry="0" width="75" height="75" />
              <rect x="560" y="295" rx="0" ry="0" width="75" height="75" />
            </ContentLoader>
        }
      </div>
    </div>
  );
};

export default IconCard;


// WEBPACK FOOTER //
// ./src/components/Widget/IconCard.js